// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@west/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { rfqQuoteDetailsInformationStyles } from "@west/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation";
import { mergeWithCss, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsInformationStyles.detailsGridContainer = {
    gap: 0,
    css: css`
        margin-bottom: 25px;
    `,
};

rfqQuoteDetailsInformationStyles.expirationDateGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        &&& {
            margin-bottom: 10px;
        }
    `,
};

rfqQuoteDetailsInformationStyles.expirationDateDatePicker = {
    cssOverrides: {
        datePicker: css`
            width: 200px;
        `,
        formField: css`
            label {
                font-size: 14px;
                line-height: 22px;
                font-weight: bold;
                margin-right: 4px;
            }
        `,
    },
};

rfqQuoteDetailsInformationStyles.expirationDateTextGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
        ${xScreen("lte", "sm")} {
            flex-direction: row;
        }
    `,
};

rfqQuoteDetailsInformationStyles.expirationDateLabelText = {
    ...xOrderInformationStyles.labelWithDots,
};

rfqQuoteDetailsInformationStyles.expirationDateValue = {
    ...xOrderInformationStyles.value,
};

rfqQuoteDetailsInformationStyles.headingAndTextData = {
    ...xOrderInformationStyles.headingAndTextStyles,
};

rfqQuoteDetailsInformationStyles.jobNameGridItem = {
    width: [12, 12, 6, 6, 6],
};

rfqQuoteDetailsInformationStyles.salesRepGridItem = {
    width: [12, 12, 6, 6, 6],
};

rfqQuoteDetailsInformationStyles.userGridItem = {
    width: [12, 12, 6, 6, 6],
};

rfqQuoteDetailsInformationStyles.statusGridItem = {
    width: [12, 12, 6, 6, 6],
};

rfqQuoteDetailsInformationStyles.dateLabelText = {
    ...xOrderInformationStyles.labelWithDots,
};

rfqQuoteDetailsInformationStyles.dateValue = {
    ...xOrderInformationStyles.value,
};

rfqQuoteDetailsInformationStyles.dateGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
        ${xScreen("lte", "sm")} {
            flex-direction: row;
        }
    `,
};

rfqQuoteDetailsInformationStyles.customerGridItem = {
    width: [12, 12, 6, 6, 6],
};

rfqQuoteDetailsInformationStyles.shipToGridItem = {
    width: [12, 12, 6, 6, 6],
};

rfqQuoteDetailsInformationStyles.notesGridItem = {
    width: 12,
};

rfqQuoteDetailsInformationStyles.notesHeadingAndText = {
    heading: {
        size: 14,
        lineHeight: "22px",
        weight: "bold",
        transform: "none",
        css: css`
            margin-right: 4px;
        `,
    },
    wrapper: {
        css: css`
            flex-direction: column;
        `,
    },
    text: {
        size: 14,
        lineHeight: "22px",
        css: css`
            &:empty:after {
                content: "- -";
            }
        `,
    },
};
